import { render, staticRenderFns } from "./Flamingo.vue?vue&type=template&id=63874369&"
import script from "./Flamingo.vue?vue&type=script&lang=js&"
export * from "./Flamingo.vue?vue&type=script&lang=js&"
import style0 from "./Flamingo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports